import { Activity } from './activity';
import { Entity } from './entity';

export class Branch extends Entity {
    public id: number;
    public key: string;
    public name: string;
    public activities: Activity[];
  }  